import { defineMessages } from 'react-intl';

const messages = defineMessages({
  certificationsCountName: {
    id: 'App.ManageGrossRents.GrossRentCertifications.certificationsCountName',
    defaultMessage: 'Certifications',
  },
  actions: {
    id: 'App.ManageGrossRents.GrossRentCertifications.actions',
    defaultMessage: 'Actions',
  },
  editCertification: {
    id: 'App.ManageGrossRents.GrossRentCertifications.editCertification',
    defaultMessage: 'Edit Certification',
  },
  editCertificationDisabledTooltip: {
    id: 'App.ManageGrossRents.GrossRentCertifications.editCertificationDisabledTooltip',
    defaultMessage:
      'Editing is unavailable when a prior full certification exists',
  },
  editGrossRentCertificationModalTitle: {
    id: 'App.ManageGrossRents.GrossRentCertifications.editGrossRentCertificationModalTitle',
    defaultMessage: 'Edit Gross Rent Certification',
  },
  cancelCertification: {
    id: 'App.ManageGrossRents.GrossRentCertifications.cancelCertification',
    defaultMessage: 'Cancel Certification',
  },
  cancelCertificationModalTitle: {
    id: 'App.ManageGrossRents.GrossRentCertifications.cancelCertificationModalTitle',
    defaultMessage: 'Cancel Certification',
  },
  cancelCertificationModalBody: {
    id: 'App.ManageGrossRents.GrossRentCertifications.cancelCertificationModalBody',
    defaultMessage:
      'Are you sure you want to cancel the Gross Rent Certification for: Unit {unit} - {headOfHousehold}?',
  },
  cancelCertificationSuccess: {
    id: 'App.ManageGrossRents.GrossRentCertifications.cancelCertificationSuccess',
    defaultMessage: 'Gross Rent Certification canceled',
  },
  errorCancellingCertification: {
    id: 'App.ManageGrossRents.GrossRentCertifications.errorCancellingCertification',
    defaultMessage: 'Failed to cancel the Gross Rent Certification. {errorMessage}',
  },
  errorLoading: {
    id: 'App.ManageGrossRents.GrossRentCertifications.errorLoading',
    defaultMessage: 'Error loading gross rent certifications',
  },
  loadError: {
    id: 'App.ManageGrossRents.GrossRentCertifications.loadError',
    defaultMessage:
      'Unable to load gross rent certifications. Please try again.',
  },
  retry: {
    id: 'App.ManageGrossRents.GrossRentCertifications.retry',
    defaultMessage: 'Try again',
  },
  effectiveDateLabel: {
    id: 'App.ManageGrossRents.GrossRentCertifications.effectiveDateLabel',
    defaultMessage: 'Effective Date',
  },
  missingDataLegend: {
    id: 'App.ManageGrossRents.GrossRentCertifications.missingDataLegend',
    defaultMessage:
      'Certifications highlighted in red require additional information before they ' +
      'can be completed or a 59A can be generated.',
  },
  missingPriorCertBullet: {
    id: 'App.ManageGrossRents.GrossRentCertifications.missingPriorCertBullet',
    defaultMessage:
      'Rows highlighted in red do not have a prior full certification to pull required ' +
      'data from. Go to <b>Actions > Edit Certification</b> to enter the required ' +
      'information to then generate the 59A and complete the Gross Rent Certification.',
  },
  noChangeBullet: {
    id: 'App.ManageGrossRents.GrossRentCertifications.noChangeBullet',
    defaultMessage:
      'If the assistance details for the Gross Rent Certification do not have a change ' +
      'from the prior certification, the column will list <b>NC*</b> for <b>No Change</b>.',
  },
  grossRentHistoryBullet: {
    id: 'App.ManageGrossRents.GrossRentCertifications.grossRentHistoryBullet',
    defaultMessage:
      'If you need to make edits to these Gross Rent Certifications, you can manage ' +
      'them in the Gross Rent History.',
  },
  completeCertifications: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertifications',
    defaultMessage: 'Complete Certifications',
  },
  completeCertificationsModalTitle: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsModalTitle',
    defaultMessage: 'Complete Gross Rent Certifications',
  },
  completeCertificationsModalBodyIntro: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsModalBodyIntro',
    defaultMessage:
      'Completing these Gross Rent Certifications for {effectiveDate} will update the ' +
      'household’s Gross Rent and/or Utility Allowance values based on the Effective Date ' +
      'and finalize the Gross Rent Certification for all households.',
  },
  completeCertificationsModalBodyPrompt: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsModalBodyPrompt',
    defaultMessage:
      'Do you want to continue with completing these Gross Rent Certifications?',
  },
  completeCertificationsLockInfoBanner: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsLockInfoBanner',
    defaultMessage:
      'After completion, this Gross Rent Change will be locked from editing or deleting ' +
      'within the history.',
  },
  completeCertificationsMissingDataWarningBanner: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsMissingDataWarningBanner',
    defaultMessage:
      'There is at least one Gross Rent Certification with missing required data. Those ' +
      'certifications will not be included in this completion.',
  },
  completeCertificationsSuccess: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsSuccess',
    defaultMessage: 'Gross Rent Certifications completed successfully',
  },
  completeCertificationsInProgressTitle: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsInProgressTitle',
    defaultMessage: 'In Progress',
  },
  completeCertificationsInProgressMessage: {
    id: 'App.ManageGrossRents.GrossRentCertifications.completeCertificationsInProgressMessage',
    defaultMessage:
      'Batch processing of Gross Rent Certifications is in progress.',
  },
  errorCompletingCertifications: {
    id: 'App.ManageGrossRents.GrossRentCertifications.errorCompletingCertifications',
    defaultMessage:
      'There was an error completing the Gross Rent Certifications: {errorMessage}',
  },
  noOpenGrossRentCertsTooltip: {
    id: 'App.ManageGrossRents.GrossRentCertifications.noOpenGrossRentCertsTooltip',
    defaultMessage: 'There are no open Gross Rent Certifications',
  },
  generateAll59AsBeforeCompletingTooltip: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generateAll59AsBeforeCompletingTooltip',
    defaultMessage: "Generate all 59A's before completing certifications.",
  },
  menuDisabledMissingRequiredDataTooltip: {
    id: 'App.ManageGrossRents.GrossRentCertifications.menuDisabledMissingRequiredDataTooltip',
    defaultMessage:
      'Required information must be added to at least one GR before Gross Rents can be managed.',
  },
  tableEmptyStateMessage: {
    id: 'App.ManageGrossRents.GrossRentCertifications.tableEmptyStateMessage',
    defaultMessage: 'No items found',
  },
  generatingAll59As: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generatingAll59As',
    defaultMessage: "Generating All 59A's",
  },
  willDownloadWhenComplete: {
    id: 'App.ManageGrossRents.GrossRentCertifications.willDownloadWhenComplete',
    defaultMessage: 'Will download when complete',
  },
  generateAll59As: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generateAll59As',
    defaultMessage: "Generate All 59A's",
  },
  generateAll59AsSuccess: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generateAll59AsSuccess',
    defaultMessage: "Generated All 59A's Successfully",
  },
  errorGeneratingAll59As: {
    id: 'App.ManageGrossRents.GrossRentCertifications.errorGeneratingAll59As',
    defaultMessage:
      "There was an error generating the 59A's batch: {errorMessage}",
  },
  generate59ASuccess: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generate59ASuccess',
    defaultMessage: 'Successfully generated 59A',
  },
  errorGenerating59A: {
    id: 'App.ManageGrossRents.GrossRentCertifications.errorGenerating59A',
    defaultMessage: 'There was an error generating the 59A: {errorMessage}',
  },
  unit: {
    id: 'App.ManageGrossRents.GrossRentCertifications.unit',
    defaultMessage: 'Unit',
  },
  floorPlan: {
    id: 'App.ManageGrossRents.GrossRentCertifications.floorPlan',
    defaultMessage: 'Floor Plan',
  },
  headOfHousehold: {
    id: 'App.ManageGrossRents.GrossRentCertifications.headOfHousehold',
    defaultMessage: 'Head of Household',
  },
  newGrossRent: {
    id: 'App.ManageGrossRents.GrossRentCertifications.newGrossRent',
    defaultMessage: 'New Gross Rent',
  },
  newHUDUA: {
    id: 'App.ManageGrossRents.GrossRentCertifications.newHUDUA',
    defaultMessage: 'New HUD UA',
  },
  newSubsidy: {
    id: 'App.ManageGrossRents.GrossRentCertifications.newSubsidy',
    defaultMessage: 'New Subsidy',
  },
  newResidentRent: {
    id: 'App.ManageGrossRents.GrossRentCertifications.newResidentRent',
    defaultMessage: 'New Resident Rent',
  },
  newUtilityReimbursement: {
    id: 'App.ManageGrossRents.GrossRentCertifications.newUtilityReimbursement',
    defaultMessage: 'New Utility Reimbursement',
  },
  grEffectiveDate: {
    id: 'App.ManageGrossRents.GrossRentCertifications.grEffectiveDate',
    defaultMessage: 'GR Effective Date',
  },
  anticipatedVoucherDate: {
    id: 'App.ManageGrossRents.GrossRentCertifications.anticipatedVoucherDate',
    defaultMessage: 'Anticipated Voucher Date',
  },
  priorCertificationDate: {
    id: 'App.ManageGrossRents.GrossRentCertifications.priorCertificationDate',
    defaultMessage: 'Prior Certification Date',
  },
  otherCertInProgress: {
    id: 'App.ManageGrossRents.GrossRentCertifications.otherCertInProgress',
    defaultMessage: 'Other Certification In Progress',
  },
  noticeToVacate: {
    id: 'App.ManageGrossRents.GrossRentCertifications.noticeToVacate',
    defaultMessage: 'Occupied / On NTV',
  },
  residentSignatureRequired: {
    id: 'App.ManageGrossRents.GrossRentCertifications.residentSignatureRequired',
    defaultMessage: 'Resident Signature Required',
  },
  generate59a: {
    id: 'App.ManageGrossRents.GrossRentCertifications.generate59a',
    defaultMessage: 'Generate 59A',
  },
});

export default messages;
